import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/TrophyFill.tsx
const TrophyFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 3a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1c0 1.127.275 2.819 1.143 4.264.833 1.39 2.227 2.555 4.347 2.717a5.435 5.435 0 0 0 1.998 1.52c-.064 1.334-.386 2.189-.78 2.702C8.292 17.742 7.725 18 7 18a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1c-.726 0-1.293-.258-1.707-.797-.395-.513-.717-1.368-.781-2.702a5.435 5.435 0 0 0 1.998-1.52c2.12-.162 3.514-1.327 4.348-2.716C21.725 8.819 22 7.127 22 6a1 1 0 0 0-1-1h-3V4a1 1 0 0 0-1-1H7Zm11 4v2c0 .418-.073.985-.253 1.605.61-.32 1.058-.807 1.395-1.37.42-.7.661-1.512.775-2.235H18ZM4.083 7H6v2c0 .418.073.985.253 1.605-.61-.32-1.058-.807-1.396-1.37-.42-.7-.66-1.512-.774-2.235Z",
		fill: props.fill || "currentColor"
	})
}));
export { TrophyFillIcon };
